export function contentfilter() {
  const triggerText = document.querySelectorAll('.js-content-filter-text')
  const triggerImage = document.querySelectorAll('.js-content-filter-image')
  const triggerVideo = document.querySelectorAll('.js-content-filter-video')

  if(triggerText) {
    for (let i = 0; i < triggerText.length; i++) {
      const el = triggerText[i];
      el.addEventListener('click', function(e) {
        if(document.body.classList.contains('is-hide-content-text')) {
          document.body.classList.remove('is-hide-content-text')
          Cookies.set('commonfuture-content-text', '0')
        } else {
          document.body.classList.add('is-hide-content-text')
          Cookies.set('commonfuture-content-text', '1')
        }
        e.preventDefault()
      })
    }
  }
  if(triggerImage) {
    for (let i = 0; i < triggerImage.length; i++) {
      const el = triggerImage[i];
      el.addEventListener('click', function(e) {
        if(document.body.classList.contains('is-hide-content-image')) {
          document.body.classList.remove('is-hide-content-image')
          Cookies.set('commonfuture-content-image', '0')
        } else {
          document.body.classList.add('is-hide-content-image')
          Cookies.set('commonfuture-content-image', '1')
        }
        e.preventDefault()
      })
    }
  }
  if(triggerVideo) {
    for (let i = 0; i < triggerVideo.length; i++) {
      const el = triggerVideo[i];
      el.addEventListener('click', function(e) {
        if(document.body.classList.contains('is-hide-content-video')) {
          document.body.classList.remove('is-hide-content-video')
          Cookies.set('commonfuture-content-video', '0')
        } else {
          document.body.classList.add('is-hide-content-video')
          Cookies.set('commonfuture-content-video', '1')
        }
        e.preventDefault()
      })
    }
  }
}
